import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkTitle from "../../components/atoms/TkTitle";
import { Box, Typography } from "@mui/material";
import { labelids } from "../../assets/data/TkExplanationProperty";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: (
      <Box>
        <TkTitle size="medium">手当一覧</TkTitle>
        <Typography>{labelids.labelid.LBLW040002_02}</Typography>
      </Box>
    ),
  },
  {
    title: "手当の一覧",
    keyword: "benefitsList",
    type: "text",
  },
  {
    keyword: "title2",
    type: "lineTitle",
    lineTitle: (
      <Box>
        <TkTitle size="medium">申請手当名及び対応規程</TkTitle>
        <Typography>{labelids.labelid.LBLW040002_03}</Typography>
      </Box>
    ),
  },
  {
    title: "申請手当名",
    keyword: "applyBenefitsName",
    type: "nodeInLine",
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "対応規程",
    keyword: "parallelRule",
    type: "inputWithText",
    requiredIcon: true,
    disabled: true,
    outerTextLeft: "第",
    outerTextRight: "条",
  },
  {
    title: "手当の支給金額の目安",
    keyword: "minAndMaxAmt",
    type: "limitInputGroup",
    disabledMax: true,
    disabledMin: true,
    requiredIcon: true,
  },
  {
    keyword: "title3",
    type: "lineTitle",
    lineTitle: (
      <Box>
        <TkTitle size="medium">施設情報</TkTitle>
        <Typography>{labelids.labelid.LBLW040002_04}</Typography>
      </Box>
    ),
  },
  {
    title: "対象施設",
    keyword: "targetFacilities",
    type: "checkboxGroup",
    disabled: true,
    requiredIcon: true,
  },
  {
    keyword: "title4",
    type: "lineTitle",
    lineTitle: (
      <Box>
        <TkTitle size="medium">基本事項との対応</TkTitle>
        <Typography>{labelids.labelid.LBLW040002_05}</Typography>
      </Box>
    ),
  },
  {
    title: "条文",
    keyword: "article",
    type: "label",
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "基本事項①：「負荷・困難度が高い業務に対して支給する」ことの表記",
    keyword: "checkBox1",
    type: "checkboxGroup",
    requiredIcon: true,
    checkBoxList: [{ label: "はい、表記があります", disabled: true }],
  },
  {
    title:
      "基本事項②：「業務負担が本俸額で見合わないため、その是正・調整目的で支給する」ことの表記",
    keyword: "checkBox2",
    type: "checkboxGroup",
    requiredIcon: true,
    checkBoxList: [{ label: "はい、表記があります", disabled: true }],
  },
  {
    title: "基本事項③：「支給対象となる業務内容」の具体的な表記",
    keyword: "checkBox3",
    type: "checkboxGroup",
    requiredIcon: true,
    checkBoxList: [{ label: "はい、表記があります", disabled: true }],
  },
  {
    title:
      "基本事項④：月額固定または、本俸に対する固定比率で、毎月支給することの表記",
    keyword: "checkBox4",
    type: "checkboxGroup",
    requiredIcon: true,
    checkBoxList: [{ label: "はい、表記があります", disabled: true }],
  },
  {
    keyword: "title5",
    type: "lineTitle",
    lineTitle: (
      <Box>
        <TkTitle size="medium">給与規程</TkTitle>
        <Typography>{labelids.labelid.LBLW040002_06}</Typography>
      </Box>
    ),
  },
  {
    title: "給与規程",
    keyword: "salaryRules",
    type: "downloadLink",
    requiredIcon: true,
    disabled: false,
    showLine: true,
    downloadBase64: true,
  },
  {
    keyword: "title6",
    type: "lineTitle",
    lineTitle: "非該当理由",
    showLine: false,
  },
  {
    title: "非該当理由",
    keyword: "notApplicableReason",
    type: "text",
    showLine: false,
  },
];

const headTitleList: any[] = [
  {
    headTitle: "帳票名",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
  {
    headTitle: "決裁日",
    align: "left",
  },
];

export { fakeTableList, headTitleList };
